import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import "./pricing.scss";
import { SaveUpTo, MobileSaveUpTo } from "../../Icons";
import Swal from 'sweetalert2';
import { Header } from './../../component/home-header/header';
import { Footer } from './../../component/home-footer/footer';
import { GridListsItem, FreequentlyQuestion } from "./../../component/pricing/compare.grid";
import { CreditModal } from "./../../component/pricing/credit.modal";
import { getCustomerPlan, getCoupon } from "../../axios/ApiProvider";

import { usedLogs, comparePlan_lists, GetSelectedPlan, SetSelectedPlan } from "./pricing.config.js";
import { plandata_config, plandata_config_de, plandata_config_tr, plandata_config_es} from "./pricing.config.js";
import { plandata_config_it, plandata_config_fr, plandata_config_pt} from "./pricing.config.js";
import facebookLogo from "../../assets/image/Logos/facebook_logo.png";
import instagramLogo from "../../assets/image/Logos/instagram_logo.png";
import tiktokLogo from "../../assets/image/Logos/tiktok_logo.png";
import twitterLogo from "../../assets/image/Logos/twitter_logo.png";
import youtubeLogo from "../../assets/image/Logos/youtube_logo.png";
import whatsappLogo from "./../../assets/image/Logos/whatsapp_logo.png";
const BASE_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_URL;

let mobileScreenDetect = false
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4))){
    mobileScreenDetect = true;
  }

export const PricingPage = () => {
	const theme = useTheme();
	const languageStrs = useSelector((store) => store.editdata.languageStrs)
	const [planMonthly, setplanMonthly] = useState(true);
	const [comparesitems, setcomparesitems] = useState([]);
	const loginState = useSelector((store) => store.maindata.loginState);
	const languageCode = useSelector((store) => store.maindata.languageCode);
	const [planDataList, setPlanDataList] = useState(plandata_config);
	const [couponCode, setCouponCode] = useState('');
	const [discoundVal, setDiscountVal] = useState(1);
	const [isFreeTrial, setIsFreeTrial] = useState(false);
	const [trialDurationText, setTrialDurationText] = useState('');
	useEffect(() => {
		let temp = [];
		comparePlan_lists.forEach((list) => {
			temp.push(...list);
		});
		// const resCoupon = await getCoupon(couponCode);
		getCoupon('FREETRIAL').then(res => {
			console.log('gettinng Coupon', res);
			if(res.state != "success") return;

			setIsFreeTrial(res.data.is_free_trial);
			setTrialDurationText(res.data.free_trial_period_text);
		})

		setcomparesitems(temp);
	}, []);

	useEffect(() => {
		if(languageCode == 'English'){
			setPlanDataList(plandata_config);
		}
		if(languageCode == 'Deutsch'){
			setPlanDataList(plandata_config_de);
		}
		if(languageCode == 'Türkçe'){
			setPlanDataList(plandata_config_tr);
		}
		if(languageCode == 'Espanol'){
			setPlanDataList(plandata_config_es);
		}
		if(languageCode == 'Italiano'){
			setPlanDataList(plandata_config_it);
		}
		if(languageCode == 'Français'){
			setPlanDataList(plandata_config_fr);
		}
		if(languageCode == 'Portugues'){
			setPlanDataList(plandata_config_pt);
		}
	}, [languageCode])
	const [userPlan, setUserPlan] = useState({})
	useEffect(() => {
		if (!!loginState) {
			(async () => {
				let result = await getCustomerPlan()
				if (result.state === 'success') {
					setUserPlan(result.data)
				}
			})()
		}
	}, [loginState])

	const [activePlan, setActivePlan] = useState(-1)
	useEffect(() => {
		let tempPlan = -1
		if (!!userPlan['product.plan']) {
			tempPlan = Number(userPlan['product.plan']) || 0
			if (tempPlan > 3) {
				tempPlan = Number(tempPlan) - 3
				setplanMonthly(false)
			} else setplanMonthly(true)
		}

		setActivePlan(tempPlan)
	}, [userPlan])

	const [planModalStatus, setplanModalStatus] = useState(false);
	const [ModalPlanData, SetModalPlanData] = useState(planDataList[0][1]);

	const planModalOpen = (data) => {
		console.log("planModalOpen: " + data?.name)
		// if(!loginState){
		// 	Swal.fire({
		// 		position: "center",
		// 		icon: "success",
  		// 		text: "You need to Sign up first",
		// 		showConfirmButton: true,
		// 		confirmButtonText: "Okay",
		// 	}).then((result) => {
		// 		if (result.isConfirmed) {
		// 			window.location = `${BASE_FRONTEND_URL}/signup/`;		
		// 		}
		// 	});
		// 	return;
		// }
		if (data?.name === 'Free') return
		SetModalPlanData(data)
		setplanModalStatus(true)
		SetSelectedPlan(data.plan)
		console.log("planModalOpen - SetSelectedPlan: " + data.plan	)
	}

	const onApplyCoupon = async () => {
		const resCoupon = await getCoupon(couponCode);
		console.log(resCoupon);
		//if(resCoupon.state != "success") return;
		setCouponCode(resCoupon.data.code)
		setDiscountVal(resCoupon.data.discount_percentage);
	}

	return (
		<div>
			<Box className="pricing_containner pricing-page">
				<Box className="pricing_header">
					<Header pagename="pricing" />
				</Box>

				<Box className="content-containner pricing-page">
					<Box className={mobileScreenDetect? 'h-section top-section mt-4' : 'h-section top-section mt-5'}>
						<Box className="h-section-container">
							<Typography
							sx={{typography: {md: 'h1', sm: 'h2', xs: 'h3'}, fontWeight: '600 !important' }}
							className="hs1-Header mb-6 pb-6"
							>
							{languageStrs.online_ai_video_editor}
							</Typography>

							<div className="video-container" style={{ width: '100%', paddingTop: '56.25%', position: 'relative' }}> {/* This div acts as a container to maintain aspect ratio */}
								<iframe
									src="https://www.youtube.com/embed/sStiFfdEz6E"
									title="YouTube video player"
									frameBorder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									allowFullScreen
									style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
								></iframe>
							</div>
						</Box>
					</Box>
				</Box>
				<Box className="content-containner pricing-page">
					<Box className="plan-interval-contain coupon text-center">
						<TextField id="outlined-basic" label="Coupon Code" InputLabelProps={{shrink: true,}} value={couponCode} onChange={(e) => { setCouponCode(e.target.value); console.log(e.target.value) }} size="small" variant="outlined" />
						<Button variant="contained" className="mx-4" onClick={() => onApplyCoupon()}>
							<Typography sx={{color: '#f0f0f0'}} >Apply Coupon</Typography>
						</Button>
					</Box>
					<Box className="plan-interval-contain text-center" marginTop={5}>
						{isFreeTrial && <Typography variant="h3">{trialDurationText}</Typography>}
					</Box>
				</Box>
				<Box className="content-containner pricing-page">
					<section className="plan-interval-section">
						<Box className="plan-interval-contain">
							<Box
								className={planMonthly ? "plan-iterval-toggle-active" : "plan-iterval-toggle"}
								onClick={() => { setplanMonthly(true); }}
							>
								<Typography className="plan-iterval-text">{languageStrs.monthly}</Typography>
							</Box>

							<Box
								className={!planMonthly ? "plan-iterval-toggle-active" : "plan-iterval-toggle"}
								onClick={() => { setplanMonthly(false); }}
							>
								<Typography className="plan-iterval-text">{languageStrs.annually}</Typography>
							</Box>

							<Box className="annually-SaveUpTo-contain">
								<SaveUpTo className="saveupto-img" />
								<MobileSaveUpTo className="mobile-saveupto-img" />
								<Typography className="saveupto-text">{languageStrs.save_up_to} 43%</Typography>
							</Box>
						</Box>
					</section>

					<section className="plan-hightlight-section">
						<Box className="plan-hightlight-contain">
							{planDataList.map((planitem, index) => (
								<Box className="plan-hightlight-items" key={index}>
									{planitem.map((item, index) => (
										<Box key={index}
											className={`plan-hightlight-item ${activePlan !== item.plan ? item.plan == 0 && activePlan == -1? 'custom-plan' : item.class : 'custom-plan'}`}
										>
											{(activePlan !== item.plan && item.class) && (
												<Typography className="most-popular-txt">
													{languageStrs.most_popular}
												</Typography>
											)}

											{activePlan === item.plan && (
												<Typography className="custom-text">
													{languageStrs.your_plan} {!userPlan?.active ? ` / ${languageStrs.inactive}` : (
														userPlan['product.plan'] > 3 ? `/ ${languageStrs.annually}` : `/ ${languageStrs.monthly}`
													)}
												</Typography>
											)}

											<Box className="plan-hightlight-header">
												<img alt='icon-path'
													src={item.icon_path}
													className="plan-hightlight-headerimg"
												/>

												<Typography className="plan-hightlight-headertxt">
													{item.name}
												</Typography>
											</Box>

											<Typography className="plan-hightlight-description">
												{item.description}
											</Typography>

											<Box className="plan-hightlight-price">
												<Typography className="plan-hightlight-pricetxt">
													${planMonthly ? (item.monthlyprice * discoundVal).toFixed(2) : (item.Annuallyprice * discoundVal).toFixed(2)}
												</Typography>
											</Box>

											<Typography className="plan-hightlight-price-description">
												{item.monthlyprice && (
													planMonthly ? item.price_description : `${item.price_description} ($${item.Annuallyprice * 12})`
												)}
											</Typography>

											{(item.name === "Free" && !loginState) ? (
												<Link to={"./../signup"}
													className="plan-hightlight-gobtn"
												>
													{item.btnTxt}
												</Link>
											) : (
												<Box onClick={() => { planModalOpen(item) }}
													className={`plan-hightlight-gobtn ${item.name === 'Free' && ('disaled')}`}
												>
													{item.btnTxt}
												</Box>
											)}

											<Box className="plan-hightlight-featurelist">
												{item.featureList.items.map((list, index) => (
													<Box className="plan-hightlight-featurelist-item" key={index}>
														{item.featureList.icon}
														<Typography className="plan-hightlight-featurelist-txt">
															{list}
														</Typography>
													</Box>
												))}
											</Box>

											<Link to={"#"} className="plan-hightlight-footer">
												{item.footerTxt}
											</Link>
										</Box>
									))}
								</Box>
							))}
						</Box>
					</section>

					<section className="contactEnterprise-section">
						<Box className="contactEnterprise-contain">
							<Typography className="contactEnterprise-txt">
								{languageStrs.need_additional_features}
							</Typography>

							<a href="mailto:info@videoo.io" style={{ textDecoration: 'none' }}>
								<Box className="contactEnterprise-btn">{languageStrs.contact_sales}</Box>
							</a>
						</Box>
					</section>

					{/* <section className="usedByLogos-section">
						<Box className="usedByLogos-contain">
							<Box className="usedByLogos-item">
								<img src={instagramLogo} alt="instagram logo" width={100} />
							</Box>
							<Box className="usedByLogos-item">
								<img src={youtubeLogo} alt="youtube logo" width={100} />
							</Box>
							<Box className="usedByLogos-item">
								<img src={facebookLogo} alt="facebook logo" width={100} />
							</Box>
							<Box className="usedByLogos-item">
								<img src={twitterLogo} alt="twitter logo" width={100} />
							</Box>
							<Box className="usedByLogos-item">
								<img src={tiktokLogo} alt="tiktok logo" width={100} />
							</Box>
							<Box className="usedByLogos-item">
								<img src={whatsappLogo} alt="whatsapp logo" width={100} />
							</Box>
							{ {usedLogs.map((logo, index) => (
								<Box className="usedByLogos-item" key={index}>{logo}</Box>
							))} }
						</Box>
					</section> */ }

					<section className="compare-plans-section">
						<Box className="compare-plans-contain">
							<h1 className="compare-header">Compare Plans</h1>
							<Typography className="compare-description">
								All plans include all video editing features, auto subtitles,
								unlimited projects, and unlimited rendering
							</Typography>

							<Box className="compares-grid">
								<Box className="compares-grid-header-contain" sx={{background: theme.palette.background.default}}>
									<Typography className="compares-grid-headerTitle">
										Videoo.io Plans
									</Typography>

									{[...planDataList[0], ...planDataList[1]].map((item, index) => (
										<Box className="compares-grid-header-item" key={index}>
											<Box className="compares-GH-content-contain">
												<img src={item.icon_path} alt='icon-path'
													className="compares-GH-content-img"
												/>

												<Box className="compares-GH-content">
													<Typography className="compares-GH-content_T1">
														{item.name}
													</Typography>

													<Typography className="compares-GH-content_T2">
														{`$${planMonthly ? item.monthlyprice : item.Annuallyprice}/mo`}
													</Typography>
												</Box>
											</Box>

											{(item.name === "Free" && !loginState) ? (
												<Link to={"./../signup"}
													className="compares-GH-btn"
												>
													Sign Up For Free
												</Link>
											) : (
												<Box className={`compares-GH-btn ${item.name === 'Free' && ('disaled')}`}
													onClick={() => { planModalOpen(item) }}
												>
													Go {item.name}
												</Box>
											)}
										</Box>
									))}

									<hr className="compares-grid-header-bottom" />
								</Box>

								{comparesitems.map((item, index) => (
									<GridListsItem item={item} key={index} />
								))}
							</Box>
						</Box>
					</section>

					<section className="frequently-question-section">
						<Box className="frequently-question-contain">
							<Box className="frequently-question-header">
								Frequently Asked Questions
							</Box>

							<FreequentlyQuestion />
						</Box>
					</section>
				</Box>

				<Box className="pricing-footer-containner"><Footer /></Box>
			</Box>

			{ModalPlanData && (
				<CreditModal
					userPlan={userPlan}
					ModalPlanData={ModalPlanData}
					ModalStatus={planModalStatus}
					discoundVal={discoundVal}
					coupon={couponCode}
					freTrial={isFreeTrial}
					SetModalStatus={setplanModalStatus}
				/>
			)}
		</div>
	);
};
